module.exports = __webpack_public_path__ + "static/img/0541_1.6dd406d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0541_1.jpg
// module id = GFGC
// module chunks = 1